import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,
    Button, Alert, CircularProgress
} from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { ReservationService } from '../api/services/reservationService';

export default function CheckOutReservationModal({ open, onClose, reservation, tenantId, onSuccess, setNotification }) {
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (open) {
            setError(null);
        }
    }, [open]);

    const handleConfirm = async () => {
        setIsProcessing(true);
        setError(null);
        try {
            await ReservationService.checkOut(reservation.id, tenantId);
            if (setNotification) {
                setNotification({ open: true, message: 'Guest successfully checked out. Status updated to Checked-out.', severity: 'success' });
            }
            if (onSuccess) onSuccess();
            onClose();
        } catch (err) {
            const msg = err?.response?.data?.message || err?.message || 'Failed to check-out reservation';
            if (setNotification) {
                setNotification({ open: true, message: msg, severity: 'error' });
            } else {
                setError(msg);
            }
        } finally {
            setIsProcessing(false);
        }
    };

    if (!reservation) return null;

    return (
        <Dialog 
            open={open} 
            onClose={isProcessing ? undefined : onClose}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, padding: 1 } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, fontWeight: 'bold', color: 'info.main' }}>
                <ExitToAppIcon /> Check Out Guest
            </DialogTitle>
            <DialogContent dividers>
                {error && <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>{error}</Alert>}
                <DialogContentText sx={{ color: 'text.primary' }}>
                    Are you sure you want to process the check-out for this reservation? This action will transition the booking status to Checked-out, release the assigned room parameters back to the housekeeping queue, and finalize the active stay folio.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ padding: '16px 24px' }}>
                <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2 }} disabled={isProcessing}>
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="info"
                    sx={{ borderRadius: 2 }}
                    disabled={isProcessing}
                >
                    {isProcessing ? <CircularProgress size={20} color="inherit" /> : 'Confirm Check-Out'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
